export default __webpack_public_path__ + "static/media/1642.6b4aa443.png";